define('attachmentView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'galleryView',
  'pdfView', 
  'settings',
  'bootbox',
  'dateUtils',
  'imageUtils',
  'template!attachmentView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  GalleryView,
  PdfView,
  Settings,
  Bootbox,
  DateUtils,
  ImageUtils,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'attachments-attachment-view',

    ui: {
      fileName: '.file-name',
      deleteButton: '.delete-button',
      zoomButton: '.zoom-button',
      downloadButton: '.download-button',
      copyButton: '.copy-button',
      editRasterButton: '.edit-raster-button',
      editVectorButton: '.edit-vector-button',
      applyCompositionButton: '.apply-composition-button',
      aiEditButton: '.ai-edit-button',
      flagButton: '.flag-button',
      flagIcon: '.flag-icon',
      imageContent: '.image-content',
      fileInfo: '.file-info',
      fileInfoUser: '.file-info .user',
      fileInfoUserLogo: '.file-info .user .logo',
      fileInfoDate: '.file-info .creat-date',
      image: '.image-ctn img',
      loader: '.loader-2',
      error: '.error'
    },

    modelEvents: {
      'change': 'onRenderSafe',
      'change:attachment': 'render'
    },

    onRenderSafe: function() {
      if (!this.isDestroyed) {
        this.render();
      }
    },

    events: {
      'click @ui.deleteButton': 'deleteItem',
      'click @ui.downloadButton': 'downloadItem',
      'click @ui.zoomButton': 'zoomItem',
      'click @ui.copyButton': 'copyItem',
      'click @ui.editRasterButton': 'editRasterItem',
      'click @ui.editVectorButton': 'editVectorItem',
      'click @ui.applyCompositionButton': 'applyCompositionItem',
      'click @ui.aiEditButton': 'aiEditItem',
      'click @ui.flagButton': 'flagItem'
    },

    rasterImageExtensions: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'],
    // Extensions accepted for "apply to composition" — raster + common vector formats CompuzzPro can place.
    compositionImageExtensions: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'ai', 'pdf', 'eps'],

    // Vector formats the in-browser vector editor can open (AI = PDF-compatible AI only).
    vectorImageExtensions: ['svg', 'pdf', 'ai'],

    isVectorImage: function () {
      var attachment = this.model.get('attachment');
      if (!attachment || !attachment.get('fileName')) return false;
      var parts = attachment.get('fileName').split('.');
      if (parts.length < 2) return false;
      var ext = parts[parts.length - 1].toLowerCase();
      return this.vectorImageExtensions.indexOf(ext) >= 0;
    },

    isRasterImage: function () {
      var attachment = this.model.get('attachment');
      if (!attachment || !attachment.get('fileName')) return false;
      var parts = attachment.get('fileName').split('.');
      if (parts.length < 2) return false;
      var ext = parts[parts.length - 1].toLowerCase();
      return this.rasterImageExtensions.indexOf(ext) >= 0;
    },

    isCompositionImage: function () {
      var attachment = this.model.get('attachment');
      if (!attachment || !attachment.get('fileName')) return false;
      var parts = attachment.get('fileName').split('.');
      if (parts.length < 2) return false;
      var ext = parts[parts.length - 1].toLowerCase();
      return this.compositionImageExtensions.indexOf(ext) >= 0;
    },

    onRender: function () {
      
      if (this.model.get('fileName')) {
        this.$el.attr('title', this.model.get('fileName'));
        this.ui.fileName.html(this.model.get('fileName'));
      }

      if(this.model.get('uploading'))
        this.ui.loader.css('display', 'flex');
       else
        this.ui.loader.hide();

      if(this.model.get('error'))
        this.ui.error.css('display', 'flex');
      else
        this.ui.error.hide();

      if(!this.model.get('attachment')) {
        this.ui.imageContent.hide();
        this.ui.fileInfo.hide();
      } else {
        var attachment = this.model.get('attachment');

        this.ui.imageContent.css('display', 'flex');
        this.renderFileInfo(attachment);

        if (attachment.get('fileLink')) {
          var fileType = '';
          if(attachment.get('fileName')) {
            var fileItems = attachment.get('fileName').split('.');
            if(fileItems.length > 1)
              fileType = fileItems[fileItems.length - 1];
          }
          if (fileType && (fileType.toLowerCase() === 'pdf' || fileType.toLowerCase() === 'ai' || fileType.toLowerCase() === 'eps')) {
            this.ui.image.attr('src', Settings.url('base', attachment.get('fileLink')));
          } else if (fileType && fileType.toLowerCase() === 'svg') {
            this.ui.image.attr('src', Settings.url('base', attachment.get('fileLink').replace('&action=preview', '')));
          } else {
            this.ui.image.attr('src', Settings.url('base', attachment.get('fileLink').replace('&action=preview', '&action=res')));
          }
        }

        if (attachment.get('flag')) {
          this.ui.flagIcon.css('display', 'flex');
        } else {
          this.ui.flagIcon.css('display', 'none');
        }

        if (this.options.config.canDownload && attachment.get('downloadLink')) {
          this.ui.downloadButton.attr('href', attachment.get('downloadLink'));
          this.ui.downloadButton.css('display', 'flex');
        } else {
          this.ui.downloadButton.css('display', 'none');
        }

        if (this.options.config.canFlag) {
          this.ui.flagButton.css('display', 'flex');
        } else {
          this.ui.flagButton.css('display', 'none');
        }
        //-----------------
        if (this.options.config.canDelete)
          this.ui.deleteButton.css('display', 'flex');
        else
          this.ui.deleteButton.css('display', 'none');

        if (this.options.config.canZoom)
          this.ui.zoomButton.css('display', 'flex');
        else
          this.ui.zoomButton.css('display', 'none');

        if (this.options.config.canCopy)
          this.ui.copyButton.css('display', 'flex');
        else
          this.ui.copyButton.css('display', 'none');

        if (this.options.config.canEditRaster && this.isRasterImage())
          this.ui.editRasterButton.css('display', 'flex');
        else
          this.ui.editRasterButton.css('display', 'none');

        if (this.options.config.canEditVector && this.isVectorImage())
          this.ui.editVectorButton.css('display', 'flex');
        else
          this.ui.editVectorButton.css('display', 'none');

        if (this.options.config.canApplyToComposition && this.isCompositionImage())
          this.ui.applyCompositionButton.css('display', 'flex');
        else
          this.ui.applyCompositionButton.css('display', 'none');

        // same editable formats as "apply to composition": raster + pdf/ai/svg/eps
        if (this.options.config.canAiEdit && this.isCompositionImage())
          this.ui.aiEditButton.css('display', 'flex');
        else
          this.ui.aiEditButton.css('display', 'none');

        //-----------------
        if (this.options.config.copyButton && this.options.config.copyButton.title)
          this.ui.copyButton.attr('title', this.options.config.copyButton.title);
      }
    },

    // Upload date + uploader, shown under the file name. Both come from the
    // attachment json (creatDate / creatUser); rows uploaded before the
    // uploader was tracked have no creatUser, in which case only the date shows.
    renderFileInfo: function (attachment) {
      var creatDate = attachment.get('creatDate');
      var creatUser = attachment.get('creatUser');
      var titles = [];

      if (creatDate) {
        var formattedDate = DateUtils.toDateTimeFormatString(creatDate);
        this.ui.fileInfoDate.html(formattedDate);
        titles.push(formattedDate);
      } else {
        this.ui.fileInfoDate.html('');
      }

      if (creatUser) {
        var userName = _.compact([creatUser.firstName, creatUser.lastName]).join(' ');
        if (userName === '')
          userName = creatUser.nickName || creatUser.logonId || '';

        var src = '';
        if (creatUser.logo)
          src = Settings.url('file', creatUser.logo, {size: 'thumbnail'});
        else if (creatUser.logonId)
          src = ImageUtils.getLogo(null, creatUser.logonId, null, 'circle');

        if (src !== '') {
          this.ui.fileInfoUserLogo.attr('src', src);
          this.ui.fileInfoUser.css('display', 'flex');
        } else {
          this.ui.fileInfoUser.css('display', 'none');
        }

        if (userName !== '')
          titles.push(userName);
      } else {
        this.ui.fileInfoUser.css('display', 'none');
      }

      if (titles.length > 0) {
        this.ui.fileInfo.css('display', 'flex');
        this.ui.fileInfo.attr('title', titles.join(' - '));
      } else {
        this.ui.fileInfo.hide();
      }
    },

    editRasterItem: function () {
      this.trigger('edit-raster');
    },

    editVectorItem: function () {
      this.trigger('edit-vector');
    },

    aiEditItem: function () {
      this.trigger('ai-edit');
    },

    applyCompositionItem: function () {
      this.trigger('apply-composition');
    },

    downloadItem: function () {
      this.trigger('download');
    },

    flagItem: function () {
      var attachment = this.model.get('attachment');
      attachment.set('flag', !attachment.get('flag'));
      attachment.save();
      this.render();
    },

    deleteItem: function () {
      Bootbox.confirm(_.i18n('common.confirmDelete'), _.bind(function (result) {
        if (result)
          this.trigger('delete'); 
      }, this));
    },

    zoomItem: function () {
      var title = 'Attachment';
      var attachment = this.model.get('attachment');

      if(this.options.config.galleryTitle)
        title = this.options.config.galleryTitle + ' | ' + attachment.get('fileName');
      else
        title = 'Attachment: ' + attachment.get('fileName');

      var fileType = '';
      if(attachment.get('fileName')) {
        var fileItems = attachment.get('fileName').split('.');
        if(fileItems.length > 1)
          fileType = fileItems[fileItems.length - 1];
      }

      if(fileType && fileType.toLowerCase() === 'pdf') {
        PdfView.prototype.open({
          url: attachment.get('fileLink').replace('&action=preview', ''),
          title: title
        });
      } else {
        var fL = attachment.get('fileLink');
        if(fileType && (fileType.toLowerCase() === 'ai' || fileType.toLowerCase() === 'eps')) {
          fL = fL.replace('params=t', 'params=b');
        } else {
          fL = fL.replace('&action=preview', '');
        }
        GalleryView.prototype.open(
            'attachment.image:' + attachment.get('secId'),
            title,
            new Backbone.Model({urls: [fL]}));
      }   
    },

    copyItem: function () {
      this.trigger('copy');
    }
  });
});
